import { Component, Input, OnInit } from '@angular/core';
import { BaseComponent, DrawerService } from '@portals/core';

@Component({
	selector: 'portals-channel-detail-drawer',
	templateUrl: './channel-detail-drawer.component.html',
	styleUrls: ['./channel-detail-drawer.component.scss'],
})
export class ChannelDetailDrawerComponent extends BaseComponent implements OnInit {
	channelImageURL!: string;

	get channelDetail() {
		// @ts-ignore
		return this.drawer.context[1] as Record<string, unknown>;
	}

	constructor(public drawer: DrawerService<Record<string, unknown>>) {
		super();
	}

	ngOnInit(): void {
		// @ts-ignore
		this.channelImageURL = this.drawer.context[0]?.image?.url;
	}
}
